import heroBannerOrange from "../assets/images/pages/driving-lessons/orange-county.jpg";

export const commonCourses = [
  {
    id: 1,
    titleLines: ["2-Hours"],
    price: "$199",
    description: "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons",
    registerUrl: "https://driving.metrotrafficschool.com/book/8",
  },
  {
    id: 2,
    titleLines: ["4-Hours"],
    price: "$379",
    description: "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons",
    registerUrl: "https://driving.metrotrafficschool.com/book/9",
  },
  {
    id: 3,
    titleLines: ["6-Hours"],
    price: "$539",
    description: "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*",
    registerUrl: "https://driving.metrotrafficschool.com/book/10",
  },
  {
    id: 4,
    titleLines: ["8-Hours"],
    price: "$679",
    description: "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*\n\nHighway Training",
    registerUrl: "https://driving.metrotrafficschool.com/book/11",
  },
  {
    id: 5,
    titleLines: ["10-Hours"],
    price: "$799",
    description: "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*\n\nHighway Training\n\nDefensive Driving",
    registerUrl: "https://driving.metrotrafficschool.com/book/12",
  },
  {
    id: 6,
    titleLines: ["12-Hours"],
    price: "$899",
    description: "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*\n\nHighway Training\n\nDefensive Driving",
    registerUrl: "https://driving.metrotrafficschool.com/book/13",
  },
];

export const commonDisclaimer = "*If the Instructor determines the student is ready for the DMV Test, part of the hours included in the package can be used to take the DMV test in our car. Includes pick up and drop off the day of the scheduled appointment.";

export const countiesData = {
  "miami-dade": {
    title: "Miami-Dade County Driving Lessons",
    phone: "305-553-5000",
    image: heroBannerOrange, // Using same image as source files used orange-county.jpg mostly
  },
  "broward": {
    title: "Broward County Driving Lessons",
    phone: "954-922-3000",
    image: heroBannerOrange,
  },
  "palm-beach": {
    title: "Palm Beach County Driving Lessons",
    phone: "561-963-7555",
    image: heroBannerOrange,
  },
  "central-florida": { // Grouping for 407 numbers (Orange, Seminole, Osceola, Lake, Volusia share number)
    phone: "407-502-0099",
    image: heroBannerOrange,
  },
  // Specific entries if needed for lookup by exact slug
  "orange": {
    title: "Orange County Driving Lessons",
    phone: "407-502-0099",
    image: heroBannerOrange,
  },
  "seminole": {
    title: "Seminole County Driving Lessons",
    phone: "407-502-0099",
    image: heroBannerOrange,
  },
  "osceola": {
    title: "Osceola County Driving Lessons",
    phone: "407-502-0099",
    image: heroBannerOrange,
  },
  "lake": {
    title: "Lake County Driving Lessons",
    phone: "407-502-0099",
    image: heroBannerOrange,
  },
  "volusia": {
    title: "Volusia County Driving Lessons",
    phone: "407-502-0099",
    image: heroBannerOrange,
  },
};
